import type { FaireProductEntity } from "../../entity_types/product";

export const p_qryz9yqaf9: FaireProductEntity = {
  token: "p_qryz9yqaf9",
  type: "product",
  name: "NINA - RESORT '26 Beaded Thong Heel ✈️SHIPS TODAY",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/b88ed17cb73a8776bae17ddb1cf05acd25137debf3a3d8fedd509d675cd6fd4c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/089a70d935bb66df0268e8ca4ba5f0667d6f8904b07628ff4fc957e18a6580aa.jpeg",
    "https://cdn.faire.com/fastly/36dd71f3a5e5cd80edb755b38ffc658d17b1d00584bd924ffc9f196779ec3781.jpeg",
    "https://cdn.faire.com/fastly/69a0b879d0cd2372d6507692c4ad0c36afa85ca82f4ee9d503d234df6e2d45a8.jpeg",
    "https://cdn.faire.com/fastly/92050c11bb126198a624ec6bca6e16cf763e98737111b949e1227c08ca5a04f2.jpeg",
    "https://cdn.faire.com/fastly/6399003e5d2cf27dc2fb49d7f36beb4df08784a902a24d8193c4ecb76e310682.jpeg",
    "https://cdn.faire.com/fastly/904ee447e6d6de9433b43c669c082405589bea6659d8aff57c7a2419b9db26e7.jpeg",
    "https://cdn.faire.com/fastly/4ffa03d9c00f6bd4e7b4a29d1d58578cb9463f51eed3a35d5f9faa4afb62e600.jpeg",
    "https://cdn.faire.com/fastly/3bf698ddb7a7465d03b9e4ab1076c54c0fbb647cba2c01827bb35d4abead576b.jpeg",
    "https://cdn.faire.com/fastly/1cbb9d9e73f8eb3bba77019476324a9f667086c8a417f238965c9e291b0c0cea.jpeg",
    "https://cdn.faire.com/fastly/02394ac2a038b7e2cedf20ebb9764da0fae73e261b936ad0ad3ba670ffb58b05.jpeg",
    "https://cdn.faire.com/fastly/cb42595a45f9df69e5bcaa37acb7bf8cf245777918f6333b199a514e0505e800.jpeg",
    "https://cdn.faire.com/fastly/f2f969288a8a7325294a30fe0cf4fdc6fb3809171c37a57dd45a5e76e8114232.jpeg",
  ],
  priceDollars: 17.5,
  description:
    "Bold statement heels with gemstone straps, blending earthy elegance with vibrant charm. Featuring a sleek kitten heel, and multi-colored gemstone embellishments, these heels add a unique, eye-catching touch to any look. Perfect for evenings out, vacations, or adding a pop of color to your wardrobe.\n\n𝗢𝗢𝗧𝗗:\nPair these heels with a flowy midi dress, gold hoop earrings, and a woven clutch for a sophisticated yet effortless look.\n\n• Beaded thong heel\n• Rounded toe\n• Colors: Gold, Brown",
  tags: [],
  msrpDollars: 39,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:12.880Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
